import { z } from 'zod';
export const offerRequestPartnerMatchingStatusSchema = z.enum(['Active', 'Accepted', 'Rejected', 'Expired']);
